import { render, staticRenderFns } from "./ownerHeadpage.vue?vue&type=template&id=43f24c7c&scoped=true"
import script from "./ownerHeadpage.vue?vue&type=script&lang=js"
export * from "./ownerHeadpage.vue?vue&type=script&lang=js"
import style0 from "./ownerHeadpage.vue?vue&type=style&index=0&id=43f24c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f24c7c",
  null
  
)

export default component.exports